import { createContext, useContext, useState, useEffect } from 'react';
import { useParams } from 'react-router';
import PropTypes from 'prop-types';
import { authedApiFetch } from 'utils/Api';

const IRWorkstationContext = createContext(null);

export const useIRWorkstation = () => {
	const context = useContext(IRWorkstationContext);
	if (!context) {
		throw new Error(
			'useIRWorkstation must be used within IRWorkstationProvider'
		);
	}
	return context;
};

export const IRWorkstationProvider = ({ children, onOpenNewsFeedDrawer }) => {
	const { tenantId } = useParams();
	const [tenant, setTenant] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	const [selectedEntity, setSelectedEntity] = useState(null);

	useEffect(() => {
		const fetchTenant = async () => {
			if (!tenantId) {
				setLoading(false);
				return;
			}

			setLoading(true);
			setError(null);

			try {
				const data = await authedApiFetch({
					endpoint: `/tenants/${tenantId}`,
					method: 'GET',
				});
				setTenant(data);
			} catch (err) {
				setError('Failed to load tenant');
				console.error('Failed to fetch tenant:', err);
			} finally {
				setLoading(false);
			}
		};

		fetchTenant();
	}, [tenantId]);

	return (
		<IRWorkstationContext.Provider
			value={{
				tenant,
				loading,
				error,
				selectedEntity,
				setSelectedEntity,
				onOpenNewsFeedDrawer,
			}}
		>
			{children}
		</IRWorkstationContext.Provider>
	);
};

IRWorkstationProvider.propTypes = {
	children: PropTypes.node.isRequired,
	onOpenNewsFeedDrawer: PropTypes.func,
};

export default IRWorkstationContext;
